import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { UserPlus, FileText, CreditCard, Check, ArrowRight, Trophy, Shield, Users, BookOpen, Percent, Calendar } from 'lucide-react';
export function Membership() {
  const steps = [{
    number: 1,
    icon: <UserPlus className="h-6 w-6" data-id="element-272" />,
    title: 'Реєстрація',
    description: 'Створіть обліковий запис на сайті федерації та заповніть персональну інформацію в особистому кабінеті: ПІБ, дата народження, контактні дані, спортивний досвід.'
  }, {
    number: 2,
    icon: <FileText className="h-6 w-6" data-id="element-273" />,
    title: 'Оформлення документів',
    description: 'На основі внесених даних система автоматично згенерує PDF-заяву на вступ. Роздрукуйте документ, підпишіть його та завантажте скан-копію у свій особистий кабінет.'
  }, {
    number: 3,
    icon: <CreditCard className="h-6 w-6" data-id="element-274" />,
    title: 'Оплата членського внеску',
    description: 'Сплатіть річний членський внесок онлайн через особистий кабінет або за реквізитами федерації. Після підтвердження оплати ви отримаєте статус дійсного члена ФАіСУ.'
  }];
  const benefits = [{
    icon: <Trophy className="h-5 w-5 text-primary" data-id="element-275" />,
    title: 'Участь у змаганнях',
    description: 'Допуск до офіційних чемпіонатів та кубків України з альпінізму, скелелазіння та льодолазіння.'
  }, {
    icon: <Shield className="h-5 w-5 text-primary" data-id="element-276" />,
    title: 'Страхування',
    description: 'Спеціальні умови страхування для членів федерації при заняттях гірськими видами спорту.'
  }, {
    icon: <BookOpen className="h-5 w-5 text-primary" data-id="element-277" />,
    title: 'Навчальні програми',
    description: 'Участь у навчальних зборах, школах інструкторів та семінарах з підвищення кваліфікації.'
  }, {
    icon: <Users className="h-5 w-5 text-primary" data-id="element-278" />,
    title: 'Спільнота',
    description: 'Доступ до професійної спільноти альпіністів та скелелазів, обмін досвідом та контактами.'
  }, {
    icon: <Percent className="h-5 w-5 text-primary" data-id="element-279" />,
    title: 'Знижки від партнерів',
    description: 'Спеціальні ціни на спорядження, екіпіровку та послуги від партнерів федерації.'
  }, {
    icon: <Calendar className="h-5 w-5 text-primary" data-id="element-280" />,
    title: 'Спортивні розряди',
    description: 'Можливість отримання та підтвердження спортивних розрядів та звань з альпінізму і скелелазіння.'
  }];
  return <section id="membership" className="py-20 bg-gray-50 border-b border-gray-200" data-id="element-281">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-282">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-283">
          <span className="text-primary/50 font-semibold tracking-wider uppercase text-xs" data-id="element-284">
            Як приєднатися
          </span>
          <h2 className="mt-2 text-3xl font-heading font-bold text-primary" data-id="element-285">
            Членство у ФАіСУ
          </h2>
          <p className="mt-4 text-base text-gray-600 max-w-2xl mx-auto" data-id="element-286">
            Вступ до федерації відбувається в три прості кроки через особистий
            кабінет на сайті.
          </p>
        </div>

        {/* Steps */}
        <div className="max-w-5xl mx-auto mb-20" data-id="element-287">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-288">
            {/* Connecting line (desktop only) */}
            <div className="hidden md:block absolute top-10 left-[calc(16.67%+16px)] right-[calc(16.67%+16px)] h-px bg-gray-300" data-id="element-289" />

            {steps.map((step, index) => <motion.div key={step.number} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15,
            duration: 0.5
          }} className="relative flex flex-col items-center text-center" data-id="element-290">
                {/* Step number circle */}
                <div className="relative z-10 w-20 h-20 rounded-full bg-white border-2 border-primary flex flex-col items-center justify-center mb-6 shadow-sm" data-id="element-291">
                  <div className="text-primary" data-id="element-292">{step.icon}</div>
                </div>

                {/* Step number badge */}
                <div className="absolute top-0 right-1/2 translate-x-[34px] -translate-y-1 w-6 h-6 rounded-full bg-primary text-white text-xs font-bold flex items-center justify-center z-20" data-id="element-293">
                  {step.number}
                </div>

                <h3 className="text-lg font-bold text-primary mb-3" data-id="element-294">
                  {step.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed max-w-xs" data-id="element-295">
                  {step.description}
                </p>
              </motion.div>)}
          </div>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4,
          duration: 0.5
        }} className="text-center mt-12" data-id="element-296">
            <Link to="/login" className="inline-flex items-center px-8 py-3 bg-primary text-white rounded-md font-semibold text-sm hover:bg-primary-light transition-colors" data-id="element-297">
              Розпочати реєстрацію
              <ArrowRight className="ml-2 h-4 w-4" data-id="element-298" />
            </Link>
          </motion.div>
        </div>

        {/* Benefits */}
        <div className="max-w-5xl mx-auto" data-id="element-299">
          <div className="text-center mb-10" data-id="element-300">
            <h3 className="text-2xl font-heading font-bold text-primary" data-id="element-301">
              Переваги членства
            </h3>
            <p className="mt-3 text-sm text-gray-500 max-w-lg mx-auto" data-id="element-302">
              Членство у ФАіСУ відкриває доступ до офіційних змагань, навчальних
              програм та професійної спільноти.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-303">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08,
            duration: 0.4
          }} className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm" data-id="element-304">
                <div className="p-2 bg-gray-50 rounded-lg w-fit border border-gray-100 mb-4" data-id="element-305">
                  {benefit.icon}
                </div>
                <h4 className="text-sm font-bold text-primary mb-2" data-id="element-306">
                  {benefit.title}
                </h4>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-307">
                  {benefit.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}